var _style, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 278.7",
    style: {
      enableBackground: "new 0 0 1000 278.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t#lgd .st0{fill:#013a86;}\n\t#lgd  .st1{fill:url(#SVGID_1_);}\n\t#lgd  .st2{fill:url(#SVGID_00000060006454134534160270000006669834112639402384_);}\n\t#lgd  .st3{fill:url(#SVGID_00000155842708221222604300000009408281382412150178_);}\n\t#lgd  .st4{fill:url(#SVGID_00000081647810115059173480000003328532017788340110_);}\n\t#lgd  .st5{fill:url(#SVGID_00000010996333380604922770000010936017129309423026_);}\n\t#lgd  .st6{fill:url(#SVGID_00000172429396941367089110000003292911722609947026_);}\n\t#lgd  .st7{fill:url(#SVGID_00000127024570103342124390000000277340199637354428_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "lgd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.4,210.2c-37.9,0-66.4-17.6-66.4-48h46.6c0,10.7,8,15.9,18.7,15.9c9.3,0,14.8-3.3,14.8-9.9 c0-22.2-77.6,0.8-77.6-56.8c0-28,25.8-43.9,59.8-43.9c36.5,0,63.9,20.3,63.9,46.6H79.5c0-8.2-6.9-14.5-16.2-14.5 c-8,0-13.4,3.3-13.4,9c0,20,78.7-1.1,78.7,56.2C128.6,194,102,210.2,66.4,210.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.2,187.9c-7.7,14.3-22.2,22.2-40,22.2c-27.2,0-47.2-16.5-47.2-49.6V70.3h53.5v76.5 c0,15.1,5.5,22.2,15.6,22.2c10.7,0,15.9-7.1,15.9-22.2V70.3h53.5v137.1h-51.3V187.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "240.9,132 279.1,70.3 220.1,70.3 191,126.8 191,1.4 137.5,28.5 137.5,207.4 191,207.4 191,137.2  222.6,207.4 281,207.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 138.835,
    x2: 915.7065,
    y2: 138.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.5,207.4V70.3h32.9v137.1H499.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001653087208931494470000003922907403654469527_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 138.835,
    x2: 915.7065,
    y2: 138.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001653087208931494470000003922907403654469527_)"
    },
    d: "M616.6,97.7c-20.6,0-35.9,16.5-35.9,41.1 S596,180,616.6,180c17.3,0,32.1-10.1,34.8-30.2h34c-1.6,36.2-30.7,60.3-68.8,60.3c-39.5,0-68.8-29.4-68.8-71.3 s29.4-71.3,68.8-71.3c37,0,65.3,23,68.6,57.3h-34.6C648.4,106.7,633.9,97.7,616.6,97.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027573534617043922760000006983651989525780396_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 138.835,
    x2: 915.7065,
    y2: 138.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027573534617043922760000006983651989525780396_)"
    },
    d: "M699.9,207.4V70.3h32.9v137.1H699.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131357322060111465750000005669214067142629769_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 103.7046,
    x2: 915.7065,
    y2: 103.7046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000131357322060111465750000005669214067142629769_)"
    },
    points: "442.5,16.6 442.5,207.4  475.4,207.4 475.4,0  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066506945091410524830000014968257348311411101_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 153.6691,
    x2: 915.7065,
    y2: 153.6691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066506945091410524830000014968257348311411101_)"
    },
    d: "M921.5,70.3l-34.6,105.6L852.6,70.3 l-49.5,0V28.6l-32.9,16.6v25h-21.9v28.8h21.9v108.5h32.9V99.1h26.4l41.7,122.3c-8,19.2-17.6,28.3-32.9,28.3 c-6.6,0-12.9-1.4-18.1-3v29.1c5.2,1.6,13.2,3,21.1,3c34.8,0,49.6-23.3,61.2-57.1l51.8-151.4H921.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013894919364815763290000012263125450562195356_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 33.6439,
    x2: 915.7065,
    y2: 33.6439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013894919364815763290000012263125450562195356_)"
    },
    d: "M495.4,33.6c0-11.8,8.8-20.6,20.6-20.6 c12.1,0,20.6,8.8,20.6,20.6c0,11.5-8.5,20.6-20.6,20.6C504.2,54.2,495.4,45.2,495.4,33.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121963036485445708070000000821770271193040258_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5383,
    y1: 33.6439,
    x2: 915.7065,
    y2: 33.6439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121963036485445708070000000821770271193040258_)"
    },
    d: "M695.8,33.6c0-11.8,8.8-20.6,20.6-20.6 c12.1,0,20.6,8.8,20.6,20.6c0,11.5-8.5,20.6-20.6,20.6C704.6,54.2,695.8,45.2,695.8,33.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M979.4,73.4h-4.5v15.8h-3.9V73.4h-4.6v-3.2H980L979.4,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M996.3,89.3l-0.7-10.1c-0.1-1.2-0.1-2.2-0.1-3.2c-0.2,1.1-0.4,1.8-0.7,2.9l-3,10.4h-3.3l-2.7-10 c-0.2-0.9-0.6-2.3-0.8-3.4c0,1.1-0.1,2.2-0.1,3.4l-0.7,9.9h-3.8l1.8-19h4.9l2.5,9.5c0.4,1.4,0.5,2,0.7,3c0.2-1,0.4-2,0.7-3.1 l2.6-9.4h4.9l1.7,19H996.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.48da0c4e7212d4efb79a4a50757b52df.svg";
export { ForwardRef as ReactComponent };